function pageNumber(url) {
  const page = parseInt(new URL(url, location.origin).searchParams.get('page') || '1', 10);
  return page > 0 ? page : 1;
}

function pageUrl(base, page) {
  const url = new URL(base, location.origin);
  const current = new URL(location.href).searchParams;
  new Set(current.keys()).forEach((key) => {
    if (key === 'page') return;
    url.searchParams.delete(key);
    current.getAll(key).forEach((value) => url.searchParams.append(key, value));
  });
  if (page > 1) url.searchParams.set('page', page);
  else url.searchParams.delete('page');
  return url.toString();
}

function getGrid(root) {
  return root.querySelector('#product-grid');
}

async function fetchPage(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to load paginated content.');
  return new DOMParser().parseFromString(await response.text(), 'text/html');
}

function Ajaxinate(config) {
  this.settings = Object.assign({ container: '#ProductGridContainer', pagination: '#ProductPaginationContainer', offset: 100 }, config);
  this.check = this.check.bind(this);
  this.isBootstrapping = pageNumber(location.href) > 1;
  this.initialize();
}

Ajaxinate.prototype.initialize = function () {
  if (this.isBootstrapping || !document.querySelector(this.settings.pagination)) return;
  document.addEventListener('scroll', this.check);
  window.addEventListener('resize', this.check);
  this.check();
};

Ajaxinate.prototype.destroy = function () {
  document.removeEventListener('scroll', this.check);
  window.removeEventListener('resize', this.check);
};

Ajaxinate.prototype.check = function () {
  const pagination = document.querySelector(this.settings.pagination);
  if (!pagination || this.isBootstrapping) return;
  const rect = pagination.getBoundingClientRect();
  if (rect.top - this.settings.offset > window.innerHeight || rect.bottom + this.settings.offset < 0) return;
  const link = pagination.querySelector('a');
  this.destroy();
  if (link) this.loadMore(link.href);
};

Ajaxinate.prototype.loadMore = function (href) {
  const url = pageUrl(href, pageNumber(href));
  fetchPage(url)
    .then((doc) => {
      this.render(doc);
      const browserUrl = new URL(location.href);
      if (pageNumber(url) > 1) browserUrl.searchParams.set('page', pageNumber(url));
      else browserUrl.searchParams.delete('page');
      history.replaceState(history.state, '', browserUrl);
    })
    .catch((error) => {
      console.error(error);
      this.initialize();
    });
};

Ajaxinate.prototype.render = function (doc, replace, skipInitialize) {
  const source = getGrid(doc);
  const target = getGrid(document);
  const pagination = document.querySelector(this.settings.pagination);
  const newPagination = doc.querySelector(this.settings.pagination);
  let first = null;

  if (source && target) {
    if (replace) target.replaceChildren();
    first = source.firstElementChild;
    target.append(...source.children);
  }
  if (pagination) pagination.innerHTML = newPagination ? newPagination.innerHTML : '';
  if (!skipInitialize) this.initialize();
  return first;
};

Ajaxinate.prototype.bootstrapToCurrentPage = async function () {
  const target = pageNumber(location.href);
  if (target <= 1) {
    this.isBootstrapping = false;
    this.initialize();
    return;
  }

  this.destroy();
  this.isBootstrapping = true;
  try {
    let first = this.render(await fetchPage(pageUrl(location.href, 1)), true, true);
    for (let page = 2; page <= target; page++) {
      first = this.render(await fetchPage(pageUrl(location.href, page)), false, true) || first;
    }
    if (first) requestAnimationFrame(() => first.scrollIntoView({ block: 'start' }));
  } catch (error) {
    console.error(error);
  } finally {
    this.isBootstrapping = false;
    this.initialize();
  }
};

function start() {
  if (!document.querySelector('#ProductPaginationContainer')) return;
  if (window.infiniteScroll) window.infiniteScroll.destroy();
  window.infiniteScroll = new Ajaxinate();
  window.infiniteScroll.bootstrapToCurrentPage();
}

document.addEventListener('DOMContentLoaded', start);
window.addEventListener('facets-render-page', start);
